import axios from 'axios'

const state = {
    list: [],
    filter: []
}

const getters = {
    labels: state => state.list,
    filter: state => state.filter
}

const actions = {
    async fetchLabels({ commit }) {
        const response = await axios.get(process.env.VUE_APP_API_URL + '/labels/list');
        commit("SET_LABELS", response.data.labels);
    }
}

const mutations = {
    "SET_LABELS" (state, labels) {
        state.list = labels
    },
    "SET_LABELS_FILTER" (state, labels) {
        state.filter = labels.map(l => l._id)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}